import EntityList from "../entity-list/entity-list";
import { useEffect, useRef, useState } from "react";
import { IContactModel } from "src/types/models/apiModels";
import { AccountManagementViewModel } from "./account-management-view-model";
import { useAuth } from "../auth/auth-context";
import { ReactComponent as UserIcon } from "../../../assets/svg/userIcon.svg";
import ButtonPro from "src/components/atoms/primary-button/primary-button";

interface IListUsersProps {
	onSelect: (user: IContactModel) => void;
	userIdsToIgnore?: string[];
	onCancel: () => void;
}

const ListUsers: React.FC<IListUsersProps> = ({
	onSelect,
	userIdsToIgnore,
	onCancel,
}) => {
	const [data, setData] = useState<IContactModel[]>([]);
	const { user } = useAuth();

	const viewModel = useRef<AccountManagementViewModel | null>(null);

	useEffect(() => {
		fetchAccountUsers();
	}, []);

	const fetchAccountUsers = async () => {
		if (user && user.accessToken)
			viewModel.current = new AccountManagementViewModel(
				user.accessToken
			);
		const users = await viewModel.current?.getAccountContactsAsync();
		if (users) {
			if (userIdsToIgnore) {
				const filteredUsers = users.filter(
					(user) => !userIdsToIgnore.includes(user.userId ?? "")
				);
				setData(filteredUsers);
				return;
			}
			setData(users);
		}
	};
	const renderBusinessItem = (user: IContactModel) => (
		<>
			<div className="flex items-center justify-center gap-4 w-full p-2 cursor-pointer">
				<div className="flex items-center justify-start gap-2 w-full">
					<span className="bg-white p-1 rounded-full drop-shadow-md">
						<UserIcon className="h-6 w-6" />
					</span>
					<span className="font-Poppins font-semibold text-md">
						{user.firstName} {user.lastName}
					</span>
					<span className="font-Poppins font-semibold text-sm">
						{"["}
						{user.emailId}
						{"]"}
					</span>
				</div>
			</div>
		</>
	);

	return (
		<div className="flex flex-col items-start justify-center gap-8 w-full">
			{data.length > 0 ? (
				<EntityList<IContactModel>
					data={data}
					selectMode={true} // or false depending on your requirements
					onItemSelected={(selectedUser) => {
						onSelect(selectedUser);
					}}
					renderChildren={renderBusinessItem}
					canAddNew={false}
					listLabel={"Select Business"}
					filterText="Filter on business name"
					enableView={true}
					enableEdit={false}
					enableDelete={false}
				/>
			) : (
				<span className="font-Poppins font-semibold text-md w-full text-center">
					You do not have any user in your account
				</span>
			)}

			<ButtonPro
				onClick={onCancel}
				label={data.length === 0 ? "Ok" : "Cancel"}
			></ButtonPro>
		</div>
	);
};

export default ListUsers;
